import { atomFamily } from "jotai/utils";
import { atomWithDebugLabel } from "../utils";

export const isEditingTextNodeAtomFamily = atomFamily((nodeId: string) =>
  atomWithDebugLabel(false, `isEditingTextNodeAtomFamily(${nodeId})`),
);
